<template>
  <form class="container">
    <div id="pasos">
      <div id="paso_1" class="paso" v-if="pasos[1]">
        <div class="encabezado" @click="volverA(1)">
          <h1>Paso 1</h1>
          <h2>Seleccioná tu modelo y monto a financiar</h2>
          <img src="../../src/assets/arrow.png" :class="paso == 1 ? 'rotado' : ''" />
        </div>
        <div class="cuerpo" v-if="paso == 1">
          <div class="row">
            <div class="col-12 col-sm-6">
              <span id="spacing1"></span>
              <div class="form-group">
                <float-label label="Modelo" fixed>
                  <vSelect :options="modelos" :on-change="obtenerVersiones" v-model="modeloSeleccionado" resetOnOptionsChange placeholder="" class="customSelect" maxHeight="240px" />
                </float-label>
              </div>
              <transition name="fade">
                <div class="form-group" v-if="modeloSeleccionado">
                  <float-label label="Versión" fixed>
                    <vSelect :options="versiones" label="version" :on-change="mostrarPrecio" v-model="versionSeleccionada" resetOnOptionsChange placeholder="" class="customSelect" />
                  </float-label>
                </div>
              </transition>
              <transition name="fade">
                <div class="form-group margin-1" v-if="montos.size">
                  <float-label label="Valor estimado" fixed>
                    <input class="form-control" type="text" name="estimado" :value="valorFormateado" readonly="readonly" />
                  </float-label>
                </div>
              </transition>
            </div>
            <div class="col-12 col-sm-6">
              <transition name="fade">
                <div class="imagen" v-if="imagenModelo">
                  <img :src="ruta+'/../'+imagenModelo" />
                </div>
              </transition>
            </div>
          </div>
          <div class="row">
            <transition name="fade">
              <div class="w-100">
                <div class="col-12 col-sm-6" v-if="montos.size">
                  <h3>Seleccioná el monto a financiar</h3>
                  <div class="campanas form-group" v-if="montos.size">
                    <div class="radio" v-for="monto in montos" :key="monto">
                      <input name="monto" type="radio" @click="montoElegido=monto;mostrarInput=false;" />
                      <label>
                        <span class="radio-custom"></span> $<span v-text="monto.toLocaleString('de-DE')"></span>
                      </label>
                    </div>
                    <div class="radio fix">
                      <input name="monto" type="radio" @click="montoElegido = '';mostrarInput=true;" />
                      <label class="d-block d-sm-flex w-100 align-items-center">
                        <span class="radio-custom"></span> <span style="white-space: nowrap;">Ingresá otro monto</span>
                        <div v-if="mostrarInput" id="volando">
                          <input type="text" class="form-control efecto" v-model="montoElegido" placeholder="Monto a financiar" @keypress="isNumber($event)" @blur="editarMonto()" @keyup.enter="editarMonto()" />
                          <span id="aclaracion" v-text="'Entre $'+min.toLocaleString('de-DE')+' y $'+max.toLocaleString('de-DE')"></span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="valor">
                  <div class="siguiente">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                      <button type="button" class="btn azul" @click="verCuotas();" :disabled="!montoElegido || !modeloSeleccionado || !consulta || montoElegido < min || montoElegido > max">Siguiente</button>
                      <p class="asterisco">* La presente no podrá interpretarse como oferta de venta al público. Los precios son indicados a modo  orientativo.  Corresponden  a  la  lista  de  precios  sugeridos  a  público  por  Volkswagen Argentina  S.A.  a  sus  Concesionarios,  vigente  del  dia  <span v-text="de"></span>  al  <span v-text="vigencia"></span>.  Los  precios  se  encuentran sujetos  a  modificación  sin  previo  aviso.  Incluyen  IVA.  No  incluyen  costos  de  flete,  seguro, administrativos ni patentamiento y corresponden a modelos con pintura sólida. Tampoco incluyen el  costo  de  mano  de  obra  para  la  instalación  de  accesorios.  La  información  sobre  precios, productos  o  servicios  puede  ser  solicitada  a  cualquiera  de  los  Concesionarios  de  la  Red Volkswagen que se detallan en este Sitio. Disponibilidad sujeta a stock de los concesionarios.<br/><br/>
                      ** Paso 1 de 4 para completar la simulación. Los términos legales se visualizarán en el Paso 4.</p>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div id="paso_2" class="paso" v-if="pasos[2]">
        <div class="encabezado" @click="volverA(2)">
          <h1>Paso 2</h1>
          <h2>Elegí tu financiación</h2>
          <img src="../../src/assets/arrow.png" :class="paso == 2 ? 'rotado' : ''" />
        </div>
        <div class="cuerpo" v-if="paso == 2">
          <h3 class="cobertura header">Seleccioná tu cuota promedio y duración del préstamo.</h3>
          <div class="row">
            <transition name="fade">
              <div class="col-12" v-if="Object.keys(cuotas).length">
                <div class="table">
                  <div class="table-scroll">
                    <table class="table-main">
                      <thead>
                        <tr>
                          <th class="fix-col"></th>
                          <th v-for="(columna, cantidad) in cuotaje" :key="cantidad">
                            <p v-text="cantidad+' meses'"></p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cuota in cuotas" :key="cuota.campCod">
                          <td class="fix-col"><div class="alinear" v-text="cuota.campDesc"></div></td>
                          <td v-for="(columna, cantidad) in cuotaje" :key="cantidad">
                            <div v-if="columna[cuota.campCod]" class="alinear">
                              <input type="radio" name="seleccionado" @click="seleccionarData(cuota.campCod, columna[cuota.campCod], cuota.campDesc)" />
                              <p><span v-text="'$'+parseInt(columna[cuota.campCod].importe).toLocaleString('de-DE')"></span>* <small class="tna" v-text="'TNA '+columna[cuota.campCod].tna+'%'"></small></p>
                            </div>
                            <p v-else>-</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <div class="siguiente">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                      <button type="button" class="btn azul" @click="irA(3)" :disabled="!campana">Siguiente</button>
                      <p class="asterisco">* Incluye amortización de capital, intereses e IVA sobre intereses. NO incluye seguro automotor.
                      <br/>** Paso 2 de 4 para completar la simulación. Los términos legales se visualizarán en el Paso 4.</p>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div id="paso_3" class="paso" v-if="pasos[3]">
        <div class="encabezado" @click="volverA(3)">
          <h1>Paso 3</h1>
          <h2>Completá los siguientes datos para <br/>calcular el seguro de tu vehículo</h2>
          <img src="../../src/assets/arrow.png" :class="paso == 3 ? 'rotado' : ''" />
        </div>
        <div class="cuerpo" v-if="paso == 3">
          <div id="subpasos">
            <div class="subpaso" v-if="subpasos[1]">
              <div class="row">
                <div class="form-group col-12 col-sm-4">
                  <float-label>
                    <input type="text" @keypress="isNumber($event)" @blur="editarCP()" @keyup="editarCP()" class="form-control efecto" name="cp" v-model="cp" placeholder="Código postal (sólo números)" />
                    <span class="focus-border"></span>
                  </float-label>
                  <a href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank" style="color: #293043; font-weight: 300;"><small>Averiguar mi CPA</small></a>
                </div>
                <div class="form-group col-12 col-sm-8">
                  <float-label>
                    <input type="email" class="form-control efecto" name="email" v-model="email" placeholder="email" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="siguiente">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                      <button class="btn azul" type="button" @click="verSeguros()" :disabled="!cp">Siguiente</button>
                      <p class="asterisco">* Paso 3 de 4 para completar la simulación. Los términos legales se visualizarán en el Paso 4.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="subpaso" v-if="subpasos[2]">
              <div class="row">
                <transition name="fade">
                  <div class="col-12" v-if="Object.keys(seguros).length">
                    <h3 class="cobertura header">Seguros disponibles</h3>
                    <div class="table">
                      <div class="table-scroll">
                        <table class="table-main">
                          <thead>
                            <tr>
                              <th class="fix-col"><p><strong>Elegí tu cobertura</strong></p></th>
                              <th v-for="tipo in seguros.tipoCoberturaCabeceras" :key="tipo.id">
                                <p class="text-capitalize" v-text="tipo.descripcion"></p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="cobertura in seguros.cotizacionesMinimas" :key="cobertura.idCompania">
                              <td class="fix-col">
                                <p v-text="cobertura.companiaDescr"></p>
                              </td>
                              <td v-for="tipo in seguros.tipoCoberturaCabeceras" :key="tipo.id">
                                <p class="d-flex align-items-center" v-if="getValor(cobertura.tiposCobertura, tipo.id)"><input type="radio" name="detallado" @click="tipoElegido = tipo.descripcion; tipoCobertura = tipo.id; compania = cobertura.idCompania; aseguradora = cobertura.companiaDescr; seguro = getValor(cobertura.tiposCobertura, tipo.id)" /><span><span class="desde">desde &nbsp;</span><span v-text="'$' + getValor(cobertura.tiposCobertura, tipo.id).toLocaleString('de-DE')"></span></span></p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <div>
                <div class="siguiente">
                  <div class="d-flex align-items-center flex-column flex-sm-row">
                    <button class="btn azul" type="button" @click="verDetalle()" :disabled="!seguro">Siguiente</button>
                    <p class="asterisco">* Paso 3 de 4 para completar la simulación. Los términos legales se visualizarán en el Paso 4.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="subpaso" v-if="subpasos[3]">
              <transition name="fade">
                <div class="tabla" v-if="Object.keys(detalle.detalleCotizaciones).length">
                  <h3 class="cobertura header"><span v-text="aseguradora"></span> - <span v-text="tipoElegido"></span></h3>
                  <div class="table">
                    <div class="table-scroll">
                      <table class="table-main fixed">
                        <thead>
                          <tr>
                            <th class="fix-col"><p>&nbsp;</p></th>
                            <th>PRECIO</th>
                            <th v-for="cabecera in detalle.tipoComentarioCabeceras" :key="cabecera.codigo" v-text="cabecera.descripcion"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="plan in detalle.detalleCotizaciones" :key="plan.idCotizacionInterno">
                            <td class="fix-col">
                              <div class="d-flex align-items-center">
                                <input type="radio" name="detallado" @click="cotizacion = plan.idCotizacionInterno; datos = plan;" />
                                <p v-text="plan.descripcion" class="azul"></p>
                              </div>
                            </td>
                            <td v-text="'$'+parseInt(plan.importe).toLocaleString('de-DE')"></td>
                            <td v-for="cabecera in detalle.tipoComentarioCabeceras" :key="cabecera.codigo">
                              <div class="detalle" :class="'detalle_'+cabecera.codigo" v-html="traerTipoComentario(plan.listaTiposComentarios, cabecera.codigo)"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </transition>
              <div>
                <div class="siguiente">
                  <div class="d-flex align-items-center flex-column flex-sm-row">
                    <button class="btn azul" type="button" @click="verCuadro()" :disabled="!cotizacion">Siguiente</button>
                    <p class="asterisco">* Paso 3 de 4 para completar la simulación. Los términos legales se visualizarán en el Paso 4.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="botonera" v-if="0">
            <button type="button" @click="irASubpaso(1)" :class="subpaso == 1 ? 'actual' : ''"></button>
            <button type="button" @click="irASubpaso(2)" :class="subpaso == 2 ? 'actual' : ''" :disabled="subpaso < 2"></button>
            <button type="button" @click="irASubpaso(3)" :class="subpaso == 3 ? 'actual' : ''" :disabled="subpaso < 3"></button>
          </div>
        </div>
      </div>
      <div id="paso_4" class="paso" v-if="pasos[4]">
        <div class="encabezado" @click="volverA(4)">
          <h1>Paso 4</h1>
          <h2>Visualizá tu opción elegida</h2>
          <img src="../../src/assets/arrow.png" :class="paso == 4 ? 'rotado' : ''" />
        </div>
        <div class="cuerpo" v-if="paso == 4">
          <div>
            <table class="table table-sm mt-5">
              <tbody>
                <tr>
                  <td scope="row">Modelo</td>
                  <td><span v-text="modeloSeleccionado"></span> - <span v-text="versionSeleccionada.version"></span></td>
                </tr>
                <tr>
                  <td scope="row">Monto a financiar</td>
                  <td><span v-text="'$'+parseInt(montoElegido).toLocaleString('de-DE')"></span></td>
                </tr>
                <tr>
                  <td scope="row">Financiación</td>
                  <td><span v-text="seleccionado.plazo+' meses'"></span> (<span v-text="tituloCampana"></span> - TNA <span v-text="seleccionado.tna"></span>%)</td>
                </tr>
                <tr>
                  <td scope="row">Seguro</td>
                  <td style="max-width: 300px;"><span v-text="aseguradora"></span> - <span v-text="datos.descripcion"></span> - ($<span v-text="parseInt(datos.importe).toLocaleString('de-DE')"></span>)</td>
                </tr>
                <tr>
                  <td scope="row" style="border-bottom: 1px solid #E6DDCF;"><strong>Valor cuota promedio</strong></td>
                  <td style="border-bottom: 1px solid #E6DDCF;"><strong>$<span v-text="parseInt(cuadro[Math.floor(cuadro.length / 2) - 1].total).toLocaleString('de-DE')"></span></strong>*</td>
                </tr>
              </tbody>
            </table>
            <p><small>* La cuota incluye amortización de capital, intereses, IVA sobre intereses y seguro automotor.<br/><span style="opacity: 0;">* </span>El seguro cotizado contempla la opción más económica para la información brindada. VWFS ofrece varias alternativas de aseguradora y coberturas, para más información por favor ingresá a <a href="https://www.vwfs.com.ar/financiacion.html" target="_blank">https://www.vwfs.com.ar/financiacion.html</a>.</small></p>
            <div>
              <div class="siguiente">
                <div class="d-flex align-items-center flex-column flex-sm-row">
                  <button v-if="!marcha" class="btn azul" type="button" @click="marcha = true">Ver resumen de cuotas</button>
                  <button v-if="marcha" class="btn azul" type="button" @click="marcha = false">Ocultar resumen de cuotas</button>
                </div>
              </div>
            </div>
            <div id="marcha">
              <transition name="fade">
                <div class="tabla" v-if="Object.keys(cuadro).length && marcha">
                  <div class="table">
                    <div class="table-scroll">
                      <table class="table-main">
                        <thead>
                          <tr class="todos-min">
                            <th class="min-width"></th>
                            <th>Cuota pura</th>
                            <th>Impuestos</th>
                            <th>Seguro</th>
                            <th>Cuota total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in cuadro" v-bind:key="index">
                            <td v-text="row.cuota"></td>
                            <td v-text="'$'+parseInt(row.pura).toLocaleString('de-DE')"></td>
                            <td v-text="'$'+parseInt(row.impuestos).toLocaleString('de-DE')"></td>
                            <td v-text="'$'+parseInt(row.seguro).toLocaleString('de-DE')"></td>
                            <td v-text="'$'+parseInt(row.total).toLocaleString('de-DE')"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <span id="spacing_2"></span>
            <h3 class="cobertura header">Dejanos tus datos para ponernos en contacto</h3>
            <form>
              <div class="form-row">
                <div class="col-12 col-md-4">
                  <float-label>
                    <input @keypress="isLetter($event)" type="text" class="form-control efecto" name="nombre" v-model="nombre" placeholder="Nombre" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-4">
                  <float-label>
                    <input type="text" @keypress="isLetter($event)" class="form-control efecto" name="apellido" v-model="apellido" placeholder="Apellido" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-4">
                  <float-label>
                    <input @keypress="isNumber($event)" type="text" class="form-control efecto" name="dni" v-model="dni" placeholder="DNI"  @blur="dni == '' ? dni = 0 : ''" v-on:keyup="setNumber" :class="{danger: dni.toString().length && !dniValido}" maxlength="8" min="999999" max="99999999" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 col-md-3">
                  <float-label>
                    <input @keypress="isNumber($event)" @blur="editarCP()" @keyup="editarCP()" type="text" class="form-control efecto" name="codigo" v-model="cp" placeholder="Código postal" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-2">
                  <float-label>
                    <input @keypress="isNumber($event)" maxlength="4" type="text" v-on:blur="setMaxLength" v-on:keyup="setNumber" class="form-control efecto" name="area" v-model="area" placeholder="Código de área" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-3">
                  <float-label>
                    <input @keypress="isNumber($event)" :maxlength="maxLength" type="text" v-on:blur="setMaxLength" v-on:keyup="setNumber" class="form-control efecto" name="telefono" v-model="telefono" placeholder="Teléfono" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-4">
                  <float-label>
                    <input type="text" class="form-control efecto" :class="{danger: email.length > 0 && !emailValido}" name="e-mail" v-model="email" placeholder="E-mail" />
                    <span class="focus-border"></span>
                  </float-label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 col-md-6">
                  <float-label label="Provincia">
                    <select name="provincia" class="form-control efecto no-appearance" placeholder="Provincia" v-model="provincia">
                      <option selected value>Provincia</option>
                      <option v-for="provincia in provincias" :key="provincia" :value="provincia">{{provincia}}</option>
                    </select>
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12 col-md-6">
                  <float-label label="Concesionario">
                    <select name="concesionaria_id" class="form-control efecto no-appearance" placeholder="Concesionario" v-model="concesionario">
                      <option selected value>Concesionario</option>
                      <option v-if="Object.keys(select_concesionarias).length" v-for="concesionaria in select_concesionarias" :key="concesionaria.codigo" :value="concesionaria.codigo">{{ concesionaria.nombre }} - {{ concesionaria.direccion }}</option>
                      <option v-else>Elegir provincia primero</option>
                    </select>
                    <span class="focus-border"></span>
                  </float-label>
                </div>
                <div class="col-12">
                  <div id="acepto" class="d-flex align-items-start justify-content-between"><input type="checkbox" name="consentimiento" v-model="consentimiento"><p><small>Acepto  que  mis  datos  personales  sean  compartidos  por  Volkswagen  Argentina  S.A.  con VOLKSWAGEN    FINANCIAL    SERVICES    COMPAÑÍA    FINANCIERA    S.A.    y/o    con    el Concesionario de la Red Volkswagen por mi seleccionado, con la finalidad de poder enviarme información  respecto  de  el/los  producto/s  por  mi  solicitado/s.  Acepto  que  mis  datos  sean incorporados  a  sus  bases  de  datos  con  la  finalidad  de  responder  mis  consultas  y  solicitudes, enviarme  información  sobre  otros  productos  y  servicios  y  realizar  encuestas.  Conforme  la Disposición  DNPDP  N°  10/08:  El  titular  de  los  datos  personales  tiene  la  facultad  de  ejercer  el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326. La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</small></p></div>
                </div>
              </div>
            </form>
            <div>
              <div class="siguiente">
                <div class="d-flex align-items-center flex-column flex-sm-row">
                  <button class="btn azul" type="button" @click="enviarForm()" :disabled="!consentimiento || !concesionario || !provincia || !nombre || !apellido || !email || !emailValido || !dniValido || !area || !telefono || !dni || !cp">Contactarme</button>
                  <button :disabled="!consentimiento || !concesionario || !provincia || !nombre || !apellido || !email || !emailValido || !dniValido || !area || !telefono || !dni || !cp" class="btn azul ml-3" type="button" @click="mandarRequest">Solicitá tu préstamo</button>
                  <p class="asterisco" v-if="0">* Los precios mostrados son de carácter orientativo y pueden sufrir variaciones sin previo aviso. Los valores de las cuotas no incluyen los costos de seguros.</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="siguiente">
              <div class="d-flex align-items-center flex-column flex-sm-row">
                <div class="legales ml-auto mr-auto">
                  <h4 style="font-size: 2em;">CFTEA sin IVA: <span v-text="legales.cftSinIVAEfec.toFixed(2).toLocaleString('de-DE').replace('.', ',')"></span>%</h4>
                  <h4 style="font-size: 2em;" class="mb-4">CFTEA con IVA: <span v-text="legales.cftConIVAEfec.toFixed(2).toLocaleString('de-DE').replace('.', ',')"></span>%</h4>
                  <p>PROMOCIÓN VÁLIDA PARA LA CARTERA DE CONSUMO DEL <span v-text="legales.fechaDesdeCampana"></span> AL <span v-text="legales.fechaHastaCampana"></span> EN LA REPÚBLICA ARGENTINA EN  LA  RED  DE  CONCESIONARIOS  VOLKSWAGEN  ARGENTINA  S.A.  FINANCIACIÓN  A  CARGO  DE  VOLKSWAGEN FINANCIAL SERVICES COMPAÑÍA FINANCIERA S.A. TASA <span class="text-uppercase" v-text="legales.tipoTasa"></span> EN PESOS SISTEMA DE AMORTIZACIÓN <span class="text-uppercase" v-text="legales.sistemaAmortizacion"></span>. VÁLIDA PARA  LAS  OPERACIONES  INGRESADAS  DEL  <span v-text="legales.fechaDesdeCampana"></span> AL <span v-text="legales.fechaHastaCampana"></span> INCLUSIVE  O  HASTA  AGOTAR  STOCK  DE  10 UNIDADES PARA TODOS LOS MODELOS DE <span v-text="legales.modelo"></span>, LO QUE OCURRA PRIMERO. TASA NOMINAL ANUAL (TNA): <span v-text="legales.tna.toLocaleString('de-DE')"></span>% TASA EFECTIVA ANUAL (TEA): <span v-text="legales.tea.toFixed(2).toLocaleString('de-DE').replace('.', ',')"></span>%, COSTO FINANCIERO TOTAL (CFTEA) SIN IVA: <span v-text="legales.cftSinIVAEfec.toFixed(2).toLocaleString('de-DE').replace('.', ',')"></span>%; CFTEA CON IVA: <span v-text="legales.cftConIVAEfec.toFixed(2).toLocaleString('de-DE').replace('.', ',')"></span>%, EL CFTEA INCLUYE CAPITAL E INTERESES, IVA SOBRE INTERESES Y SEGUROS DEL AUTO.</p>
                  <p>EJEMPLO CALCULADO SOBRE <span class="text-uppercase" v-text="modeloSeleccionado"></span>&nbsp;<span  class="text-uppercase" v-text="versionSeleccionada.version"></span> PRECIO FINAL SUGERIDO: <span v-text="valorFormateado"></span> ANTICIPO DE $<span v-text="legales.anticipo.toLocaleString('de-DE')"></span>  Y  PRÉSTAMO  DE  $<span v-text="legales.montoSolicitado.toLocaleString('de-DE')"></span> CON  SEGURO  AUTOMOTOR  CON  COSTO  DE  PREMIO  MENSUAL  DEL  AUTO  DE $<span v-text="parseInt(legales.premioSeguro).toLocaleString('de-DE')"></span>  SEGÚN  COBERTURA  <span class="text-uppercase" v-text="tipoElegido"></span>  ASEGURADORA  <span class="text-uppercase" v-text="aseguradora"></span>,  COTIZACIÓN  AL <span v-text="legales.fechaCotizacion"></span>,  VEHÍCULOS  PATENTADOS  EN  LA  LOCALIDAD  CON  CÓDIGO  POSTAL  <span v-text="cp"></span>,  PROVINCIA  DE  <span class="text-uppercase" v-text="legales.provincia"></span>. CUOTAS DE $<span v-text="parseInt(legales.valorCuota).toLocaleString('de-DE')"></span> MÁS IVA SOBRE INTERESES. PLAZO ÚNICO DE FINANCIACIÓN DE <span v-text="legales.plazo"></span> MESES. MONTO MÍNIMO DE FINANCIACIÓN: $<span v-text="legales.montoMinimoFinanciacion.toLocaleString('de-DE')"></span>,   MONTO   MÁXIMO:   $<span v-text="legales.montoMaximoFinanciacion.toLocaleString('de-DE')"></span>-   ACCIONISTAS   LIMITAN   SU   RESPONSABILIDAD   A   LA INTEGRACIÓN DE LAS ACCIONES SUSCRIPTAS DE ACUERDO A LA LEY 19.550. Y 25.738. AV. CÓRDOBA 111, PISO 31, C1054AAA, CIUDAD AUTÓNOMA DE BUENOS AIRES. – CUIT Nº 30-68241957-8.</p>
                  <p>OTORGAMIENTO SUJETO AL CUMPLIMIENTO DE LOS REQUISITOS EXIGIDOS POR EL DEPARTAMENTO DE CRÉDITO DE VOLKSWAGEN  FINANCIAL  SERVICES  COMPAÑÍA  FINANCIERA  S.A.  Y  DEMÁS  CONDICIONES  DE  VINCULACIÓN.  VOLKSWAGEN FINANCIAL SERVICES COMPAÑÍA FINANCIERA S.A. ES UNA SOCIEDAD ANÓNIMA CONSTITUIDA BAJO LAS LEYES DE LA REPÚBLICA ARGENTINA CUYOS ACCIONISTAS LIMITAN SU RESPONSABILIDAD A LA INTEGRACIÓN DE LAS ACCIONES SUSCRIPTAS DE ACUERDO A LA LEY 19.550. Y 25.738. AV. CÓRDOBA 111, PISO 31, C1054AAA, CIUDAD AUTÓNOMA  DE  BUENOS  AIRES.  –  CUIT  Nº  30-68241957-8.  INFORMAMOS  QUE  EL  PRECIO  DE  VENTA  AL  PÚBLICO VIGENTE POR MODELO Y VERSIÓN ES ESTABLECIDO POR VOLKSWAGEN ARGENTINA S.A. Y PODRÁ SER CONSULTADO INGRESANDO EN WWW.VOLKSWAGEN.COM.AR.</p>
                  <p>LA PRESENTE SIMULACIÓN FUE REALIZADA EN BASE A LOS DATOS DECLARATIVOS PROVISTOS POR EL CLIENTE Y A LOS PRODUCTOS  VIGENTES  AL  DÍA  DE  LA  FECHA.  VOLKSWAGEN  FINANCIAL  SERVICES  COMPAÑÍA  FINANCIERA  S.A  SE RESERVA  EL  DERECHO  DE  EFECTUAR  MODIFICACIONES  A  SUS  PRODUCTOS  SIN  PREVIO  AVISO.  LA  PRESENTE  NO CONSTITUYE UNA GARANTÍA DE LAS CONDICIONES AQUÍ DETALLADAS.</p>
                  <p>LA PRESENTE SIMULACIÓN TIENE CARÁCTER REFERENCIAL Y NO CONTRACTUAL, PUDIENDO VARIAR EN FUNCIÓN DEL PRECIO DEL VEHICULO Y TAMBIEN DE LA TASA Y GASTOS DEL PRODUCTO FINANCIERO, RIGIENDO POR TANTO LAS CONDICIONES VIGENTES AL MOMENTO DE SU CONTRATACIÓN. EL SEGURO DEL VEHÍCULO CONTEMPLADO PODRÁ VARIAR  AL  EFECTUAR  EL  ALTA  DEFINITIVA  CONFORME  A  LA  CIA.  DE  SEGUROS  ELEGIDA,  ZONA  DE  RIESGO,  SUMA ASEGURADA.  EL  OTORGAMIENTO  DEL  PRÉSTAMO  ESTÁ  SUJETO  AL  ANÁLISIS  Y  APROBACIÓN  CREDITICIA  DEL  DEPARTAMENTO DE CRÉDITO DE VOLKSWAGEN FINANCIAL SERVICES COMPAÑÍA FINANCIERA.</p>
                  <p>EL  VALOR  DE  LA  PRIMERA  CUOTA  PODRÁ  VARIAR  EN  CASO  EN  QUE  LOS  DÍAS  CONTADOS  DESDE  LA  FECHA  DE LIQUIDACIÓN  DEL  PRÉSTAMO  A  LA  FECHA  DE  VENCIMIENTO  DE  DICHA  CUOTA,  SUPEREN  LOS  30  DÍAS.  EL  COSTO FINANCIERO  TOTAL  C/  IMPUESTOS  Y  LAS  CUOTAS  INCLUYEN  CAPITAL,  INTERESES,  IVA  SOBRE  INTERESES.  LOS ACCESORIOS   Y   ADICIONALES   SON   DE   EXCLUSIVA   RESPONSABILIDAD   DEL   CONCESIONARIO.   LOS   VALORES CORRESPONDIENTES A LOS ACCESORIOS Y A LOS ADICIONALES, NO FORMAN PARTE DE LA FINANCIACIÓN Y CORREN POR EXCLUSIVA CUENTA Y RESPONSABILIDAD DEL CONCESIONARIO.  VOLKSWAGEN FINANCIAL SERVICES COMPAÑÍA FINANCIERA S.A. ES UNA SOCIEDAD ANÓNIMA CONSTITUIDA BAJO LAS LEYES DE LA REPÚBLICA ARGENTINA CUYOS ACCIONISTAS LIMITAN SU RESPONSABILIDAD A LA INTEGRACIÓN DE LAS ACCIONES SUSCRIPTAS DE ACUERDO A LA LEY 19.550. Y 25.738. AV. CÓRDOBA 111, PISO 31, C1054AAA, CIUDAD AUTÓNOMA DE BUENOS AIRES. – CUIT Nº 30-68241957-8.</p>
                  <p>LOS  VALORES  DE  LAS  CUOTAS  INCLUYEN  EL  PREMIO  DE  SEGURO  AUTOMOTOR  SEGÚN  LA  ASEGURADORA, COBERTURA  Y  LOCALIDAD  INDICADAS.  DICHO  PREMIO  PODRÁ  REGISTRAR  VARIACIONES  SI  SE  SELECCIONA  OTRA ASEGURADORA Y/O COBERTURA Y/U OTRA ZONA DE GUARDA DEL VEHÍCULO. EL VALOR DEL SEGURO ES ESTIMADO Y  PUEDE  MODIFICARSE  EN  FUNCIÓN  DE  VARIACIONES  DE  SUMA  ASEGURADA  Y/O  TARIFA  DE  LA  ASEGURADORA ELEGIDA.</p>
                  <p>COBERTURAS  OFRECIDAS  POR  VOLKSWAGEN  BROKERS  ARGENTINA  S.A.  (ASESORES  DE  SEGUROS),  AV.  DE  LAS INDUSTRIAS  3101,  GRAL.  PACHECO  (PCIA.  DE  BUENOS  AIRES),  MATRÍCULA  DE  PRODUCTOR  ASESOR  DE  SEGUROS N°1377  OTORGADA  POR  LA  SUPERINTENDENCIA  DE  SEGUROS  DE  LA  NACIÓN  (SSN).  PARA  MÁS  INFORMACIÓN CONTACTARSE  A  LA  LÍNEA  EXCLUSIVA  VW  0800-345-8942  Y/O  A  CLIENTES_SEGUROS@VWBROKERS.COM.AR.  LOS SEGUROS  SON  EMITIDOS  POR:  ALLIANZ  ARGENTINA  COMPAÑIA  DE  SEGUROS  S.A.,  CAJA  DE  SEGUROS  S.A.,  LA MERIDIONAL  CIA.  ARGENTINA  DE  SEGUROS  S.A.,  SAN  CRISTÓBAL  SOCIEDAD  MUTUAL  DE  SEGUROS  GENERALES, SANCOR COOPERATIVA DE SEGUROS LIMITADA, ZURICH ARGENTINA CÍA DE SEGUROS S.A.</p>
                  <p>LA  PRESENTE  COTIZACIÓN  ES  REALIZADA  CONSIDERANDO  QUE  LOS  DATOS  POR  UD.  INGRESADOS  SON  ACTUALES, EXACTOS Y VERACES, Y TENDRÁ UNA VIGENCIA LIMITADA DE 2 DÍAS A CONTAR DESDE SU REALIZACIÓN. LA PRESENTE ES SOLO PARA PROPÓSITOS DE INFORMACIÓN Y NO DEBE SER CONSIDERADA COMO UNA PROPUESTA, ACEPTACIÓN NI DECLARACIÓN DE VOLUNTAD VINCULANTE DE LA COMPAÑÍA DE SEGUROS ELEGIDA NI DE VOLKSWAGEN BROKERS ARGENTINA S.A. (ASESORES DE SEGUROS).</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cargando" style="position: absolute; background: rgba(255, 255, 255, 0.7); width: 100%; height: 100%; top: 0; left: 0;z-index: 12; display: flex; justify-content: center; align-items: center;">
      <img id="loading" src="../../src/assets/loading.gif"/>
    </div>
  </form>
</template>

<script>
import vSelect from "vue-select";
import FloatLabel from "vue-float-label/components/FloatLabel";
import axios from "axios";

/* eslint-disable */
export default {
  name: "Precios",
  props: ["listaPrecios", "concesionarias", "vigencia", "query", "entorno"],
  components: {
    vSelect,
    FloatLabel
  },
  data() {
    const soapBase = process.env.NODE_ENV === "development" ? "/vwfs-proxy" : "https://vwfs.vwdigital.com.ar";
    return {
      cargando: false,
      ruta: this.entorno == "qa" ? "https://vwfs.vwdigital.com.ar/qa": "https://precios.vwcontenidos.com.ar/api",
      soap: this.entorno == "qa" ? soapBase + "/qa": soapBase + "/api",
      firma: 'https://vwfs.vwdigital.com.ar',
      externo: this.entorno == "qa" ? 'https://test1-qa.bbvafrances.com.ar/preaprobacionvwfs' : 'https://preaprobacion.vwfs.com.ar/preaprobacionvwfs/',
      consulta: 0,
      pasos: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      subpasos: {
        1: true,
        2: false,
        3: false
      },
      paso: 1,
      subpaso: 1,
      modeloSeleccionado: "",
      imagenModelo: "",
      versiones: [],
      versionSeleccionada: "",
      valor: 0,
      min: 10000,
      montoElegido: '',
      mostrarInput: false,
      campanas: [],
      campana: "",
      cuotas: [],
      cuotaje: [],
      cp: null,
      seguros: [],
      detalle: [],
      tipoElegido: '',
      tipoCobertura: 0,
      compania: 0,
      cuadro: [],
      seleccionado: [],
      seguro: 0,
      cotizacion: 0,
      email: '',
      nombre: '',
      apellido: '',
      area: '',
      telefono: '',
      dni: '',
      provincia: '',
      concesionario: '',
      select_concesionarias: [],
      aseguradora: '',
      consentimiento: false,
      legales: [],
      mobile: false,
      datos: [],
      marcha: false,
      tituloCampana: '',
      maxLength: 8
    };
  },
  mounted: function() {
    this.mobile = window.innerWidth < 767;
    if(this.query) {
      let ref = this.query;
      let modelo_elegido = '';
      let version_elegida = [];
      let self = this;
      Object.keys(this.listaPrecios.modelos).filter(function(item, k){
        Object.values(self.listaPrecios.modelos[item].versiones).filter(function(subitem, subk){
          if(subitem.id == ref) {
            modelo_elegido = item;
            version_elegida = subk;
          }
        });
      });
      setTimeout(function(){
        self.modeloSeleccionado = modelo_elegido;
      }, 500);
      setTimeout(function(){
        self.versionSeleccionada = self.listaPrecios.modelos[modelo_elegido].versiones[version_elegida];
      }, 1000);
    }
  },
  computed: {
    dniValido: function() {
      return this.dni >= 999999 && this.dni <=99999999
    },
    emailValido: function(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(String(this.email).toLowerCase())
    },
    de: function() {
      return '01'+this.vigencia.slice(2)
    },
    valorFormateado: function() {
      if(!this.valor)
        return false;
      return '$'+this.valor.toLocaleString('de-DE');
    },
    provincias: function() {
      return Object.keys(this.concesionarias).sort((a, b) =>
        a.localeCompare(b)
      );
    },
    modelos() {
      let modelos = Object.keys(this.listaPrecios.modelos);
      return modelos;
    },
    montos() {
      if(!this.campanas)
        return []
      if(Object.keys(this.campanas).length) {
        var objeto = Object.values(this.campanas).map(function(item) {
          return item.montoMaximo;
        }).sort(function(a, b){return a-b});
        return new Set(objeto);
      } else {
        return []
      }
    },
    max() {
      if(!this.campanas || !this.montos)
        return 0
      if(Object.keys(this.campanas).length)
        return Array.from(this.montos).pop()
      else
        return 0
    }
  },
  watch: {
    provincia: function(val) {
      if (val !== "") {
        this.select_concesionarias = this.concesionarias[val];
      }
    }
  },
  methods: {
    setMaxLength(){
      this.maxLength = 10 - String(this.area).length
      if(String(this.telefono).length > this.maxLength) 
        this.telefono = String(this.telefono).substring(0, this.maxLength)
    },
    setNumber(v) {
      const val = v.target.value.replace(/[^0-9]/g, "")
      if(val) {
        this[v.target.name] = Number(val)
        if(v.target.name == 'telefono') {
          this.setMaxLength()
        }
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isLetter: function(e) {
      let char = String.fromCharCode(e.keyCode);
      if(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]+$/.test(char)) return true;
      else e.preventDefault()
    },
    seleccionarData(campana, seleccionado, titulo) {
      this.campana = campana; 
      this.seleccionado = seleccionado;
      this.tituloCampana = titulo
    },
    volverA: function(paso) {
      for (var i = paso + 1; i <= Object.keys(this.pasos).length; i++) {
        this.pasos[i] = false;
      }
      if(paso == 1)
        this.valor = 0
      if(paso == 3)
        this.irASubpaso(1)
      this.irA(paso);
    },
    irA: function(paso) {
      this.pasos[paso] = true;
      this.paso = paso;
      // if(this.mobile)
      // this.scrollIntoView('paso_'+paso, 30);
      if(paso < 3) {
        this.subpaso = 1;
        this.subpasos[1] = true;
        this.subpasos[2] = false;
        this.subpasos[3] = false;
      }
    },
    irASubpaso: function(subpaso) {
      for (var i = 1; i <= Object.keys(this.subpasos).length; i++) {
        if(i != subpaso)
          this.subpasos[i] = false;
      }
      this.subpasos[subpaso] = true;
      this.subpaso = subpaso;
    },
    scrollIntoView: function(selector, offset = 0) {
      setTimeout(function(){
        window.scrollTo({ top: document.getElementById(selector).offsetTop - offset, behavior: 'smooth'});
        // window.scroll(0, );
      }, 300);
    },
    obtenerVersiones(value) {
      this.cargando = false;
      this.campanas = [];
      this.modeloSeleccionado = "";
      this.versionSeleccionada = "";
      this.valor = "";
      if (value) {
        this.imagenModelo = this.listaPrecios.modelos[value].imagen;
        this.modeloSeleccionado = value;
        this.versionSeleccionada = value;
        let versiones_temp = this.listaPrecios.modelos[value].versiones.filter(item => item.id != 0)
        this.versiones = versiones_temp.map(
          element => {
            return {
              version: element.version,
              id: element.id,
              precio: element.precio
            };
          }
        );
      } else {
        this.versiones = [];
      }
    },
    mostrarPrecio(value) {
      var self = this
      if (value) {
        this.versionSeleccionada = value;
        this.cargando = true;
        this.valor = this.versionSeleccionada.precio;
        if(value.id)
          axios.post(this.soap + "/campanas", { sesion: this.listaPrecios.sesion, id: this.versionSeleccionada.id}).then(response => {
            if(!response.data.return.status.status) {
              this.cargando = false;
              this.$swal({
                title: 'Parece que hubo un error',
                text: response.data.return.status.msg,
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'OK'
              });
            }
            this.campanas = response.data.return.listaCampanas;
            this.consulta = response.data.return.idConsulta;
            // this.valor = response.data.return.valorEstimadoAuto;
            this.cargando = false;
          }).catch(function (error) {
            self.cargando = false;
            self.$swal({
                title: 'Parece que hubo un error',
                text: error,
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'OK'
              });
          });
      } else {
        this.versionSeleccionada = value;
        this.cargando = false;
      }
    },
    editarMonto() {
      if(this.montoElegido < this.min)
        this.montoElegido = this.min
      else if (this.montoElegido > this.max)
        this.montoElegido = this.max
    },
    editarCP() {
      var original = this.cp
      var nuevo = original.replace(/\D/g,'')
      this.cp = nuevo.slice(0, 4)
    },
    verCuotas() {
      var self = this
      this.cargando = true;
      axios.post(this.soap + "/cuotas", { monto: this.montoElegido, idConsulta: this.consulta, sesion: this.listaPrecios.sesion}).then(response => {
        if(!response.data.return.status.status)
          this.$swal({
            title: 'Parece que hubo un error',
            text: response.data.return.status.msg,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        this.cuotas = response.data.return.detalleCuotaPromedio;
        this.cuotaje = response.data.cuotas;
        this.cargando = false;
        this.irA(2);
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });
    },
    getValor(objeto, cobertura) {
      var elegido = objeto.filter(function(item) {
        return item.id == cobertura;
      });
      return elegido.length ? parseInt(elegido[0].premioMinimo) : null;
    },
    mandarRequest() {
      var self = this
      this.cargando = true;

      axios.post(this.ruta + "/contactarme", { concesionario: this.concesionario, nombre: this.nombre, apellido: this.apellido, email: this.email, area: this.area, telefono: this.telefono, dni: this.dni, compania: this.aseguradora, modelo: this.modeloSeleccionado, version: this.versionSeleccionada.version, monto: this.montoElegido, importe: this.seleccionado.importe, plazo: this.plazo, entrada: 'prestamo'}).then(response => {
          this.cargando = false;
          if(response.data == 'ok')
            axios.post(this.soap + "/aplicacionPrestamo", { idConsulta: this.consulta, sesion: this.listaPrecios.sesion, codPostal: this.cp, nombre: this.nombre, apellido: this.apellido, dni: this.dni, email: this.email, area: this.area, telefono: this.telefono, provincia: this.provincia, modelo: this.versionSeleccionada.version, concesionario: this.concesionario}).then(response => {
                this.cargando = false;
                if(!response.data) {
                  this.$swal({
                    title: 'Parece que hubo un error',
                    text: response.data.return.status.msg,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                  });
                } else {
                  if(response.data != 'error') {
                    var redireccion = this.externo + '/?u='+response.data
                    window.location.href = redireccion
                  } else {
                    this.$swal({
                      title: 'No aplica a préstamo',
                      text: response.data.return.status.msg,
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonText: 'OK'
                    });
                  }
                }
            }).catch(function (error) {
              self.cargando = false;
              self.$swal({
                  title: 'Parece que hubo un error',
                  text: error,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'OK'
                });
            });
        else
          this.$swal({
            title: 'Parece que hubo un error',
            text: 'Por favor, volvé a intentar o comunicate con nosotros.',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });
    },
    verSeguros() {
      var self = this
      this.editarMonto();
      this.cargando = true;
      axios.post(this.soap + "/segurosMinimo", { codPostal: this.cp, idConsulta: this.consulta, sesion: this.listaPrecios.sesion}).then(response => {
        // console.log(response);
        this.cargando = false;
        if(!response.data) {
          this.$swal({
            title: 'Parece que hubo un error',
            text: response.data.return.status.msg,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        } else {
          this.seguros = response.data.return;
          // this.irASubpaso(2);
          this.datos.importe = response.data.return.premioMinimo;
          this.cotizacion = response.data.return.idOperacionMS;
          this.aseguradora = response.data.return.nombreAseguradora;
          this.datos.descripcion = response.data.return.descripcionCobertura
          this.verCuadro();
        }
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });;
    },
    verDetalle() {
      var self = this
      this.cargando = true;
      axios.post(this.soap + "/detalle", { compania: this.compania, tipoCobertura: this.tipoCobertura, idOperacionMS: this.seguros.idOperacionMS, idConsulta: this.consulta, sesion: this.listaPrecios.sesion}).then(response => {
        if(!response.data.return.status.status)
          this.$swal({
            title: 'Parece que hubo un error',
            text: response.data.return.status.msg,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        this.detalle = response.data.return;
        this.cargando = false;
        this.irASubpaso(3);
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });;
    },
    traerTipoComentario(objeto, cabecera) {
      var elegido = objeto.filter(function(item) {
        return item.codigo == cabecera;
      });
      if(!Object.keys(elegido).length) {
        return '<p>-</p>';
      } else {
        var string = '<p>';
        for (var i = 0; i < elegido[0].comentarios.length; i++) {
          string += elegido[0].comentarios[i]+'<br/>';
        }
        string += '</p>';
        return string;
      }
    },
    verCuadro() {
      var self = this
      this.cargando = true;
      axios.post(this.soap + "/cuadro", { seguro: this.datos.importe, campana: this.campana, seleccionado: this.seleccionado, idConsulta: this.consulta, sesion: this.listaPrecios.sesion, cotizacion: this.cotizacion, precio: this.valor, cp: this.cp, importe: this.montoElegido}).then(response => {
        if(!response.data.return.status.status)
          this.$swal({
            title: 'Parece que hubo un error',
            text: response.data.return.status.msg,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        this.cuadro = response.data.return.cuotas;
        this.legales = response.data.return.variablesLegales;
        this.cargando = false;
        this.irA(4);
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });
    },
    enviarForm() {
      var self = this
      this.cargando = true;
      axios.post(this.ruta + "/contactarme", { concesionario: this.concesionario, nombre: this.nombre, apellido: this.apellido, email: this.email, area: this.area, telefono: this.telefono, dni: this.dni, compania: this.aseguradora, modelo: this.modeloSeleccionado, version: this.versionSeleccionada.version, monto: this.montoElegido, importe: this.seleccionado.importe, plazo: this.plazo, entrada: 'contactarme'}).then(response => {
        this.cargando = false;
        if(!response.data == 'error')
          this.$swal({
            title: 'Parece que hubo un error',
            text: 'Por favor, intentá de nuevo en un rato o comunicate con nosotros.',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
        else if(response.data == 'ok')
          this.$swal({
            title: '¡Gracias por comunicarte!',
            text: 'Muy pronto uno de nuestros representantes se comunicará con vos.',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.value) {
              window.location.reload();
            }
          });
        else
          this.$swal({
            title: 'Parece que hubo un error',
            text: 'Por favor, volvé a intentar o comunicate con nosotros.',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      }).catch(function (error) {
        self.cargando = false;
        self.$swal({
            title: 'Parece que hubo un error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK'
          });
      });
    }
  }
};
</script>

<style lang="scss">
  @import "../assets/scss/_vw-tokens.scss";

  header>div>div>div>div>button {
    display: flex!important;
  }
  .rotado {
    transform: rotate(180deg);
  }
  .encabezado {
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      top: 3.5em;
      right: -1.7em;
      @media(max-width: 1441px) {
        top: 2em;
        width: 100px;
      }
      @media(max-width: 767px) {
        top: 0;
        right: -7px;
        width: 70px;
      }
    }
  }
  #pasos {
    padding-top: 5em;
    .imagen {
      width: 100%;
      img {
        width: 100%;
        @media(min-width: 767px) {
          position: absolute;
          top: 10%;
          left: 0;
        }
        @media(min-width: 1441px) {
          top: 0;
        }
      }
    }
    .paso {
      padding-bottom: 2em;
      border-bottom: 1px solid $vw-border;
      margin-bottom: 4.8em;
      &:last-child {
        border-bottom: none;
      }
    }
    #subpasos {
      padding: 3em 0;
      .subpaso {
        h3 {
          margin: 0.9em 0 0;
          &+.table {
            margin-top: 1.1em;
          }
        }
      }
    }
    #botonera {
      text-align: center;
      button {
        cursor: pointer;
        border: 2px solid $vw-blue;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin: 10px;
        background: $vw-card;
        transition: none;
        @media (max-width: 1441px) {
          width: 17px!important;
          height: 17px!important;
          display: inline-block;
        }
        &.actual {
          background: $vw-blue;
        }
        &:hover:not(:disabled):not(.actual) {
          border-color: $vw-btn-selected;
          background: $vw-btn-selected;
        }
        &:disabled {
          cursor: no-drop;
          opacity: 0.4;
        }
      }
    }
  }
  #volando {
    font-size: 0.7em; 
    font-weight: 300; 
    position: absolute; 
    left: 42%; 
    width: 60%; 
    flex: 1; 
    padding-top: 0.75em;
    @media(max-width: 769px) {
      padding-left: 2em;
    }
    @media(max-width: 767px) {
      position: relative;
      width: 100%;
      left: 0;
      padding-left: 0;
      font-size: 0.5em;
    }
    input {
      font-weight: 300;
    }
    .aclaracion {
      font-size: 0.8em; 
      color: #757575; 
      margin-top: -5px; 
      display: block;
    }
  }
  .form-group, .form-row {
    position: relative;
    color: $vw-blue;
    text-align: left;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
    &.no-margin {
      margin-bottom: 1.7em;
    }
    label {
      margin-bottom: 0;
      font-weight: 400;
      color: $vw-blue;
      text-align: left;
      letter-spacing: 0.03em;
      top: -0.9em;
      z-index: 0;
      font-size: 0.7em;
      @media(max-width: 767px) {
        font-size: 1.1em;
      }
    }
    span, div {
      &:focus {
        outline: none;
      }
    }
    input:not([type="radio"]),
    select,
    textarea {
      background-color: transparent;
      color: $vw-content;
      border: none;
      border-bottom: 1px solid $vw-input-border;
      box-shadow: none;
      border-radius: 0;
      font-size: 1.2em;
      padding: 0;
      letter-spacing: -0.035em;
      height: auto;
      min-height: 1.7em;
      @media(max-width: 767px) {
        font-size: 2em;
      }
      &.danger{
        border-color: red;
      }
      &:hover,
      &:focus {
        box-shadow: none;
        outline: none !important;
      }
      &:not([type="search"]):focus {
        outline: none !important;
        border-color: $vw-border-selected;
      }
      &.efecto ~ .focus-border {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 1px;
        background-color: $vw-border-selected;
        transition: 0.4s;
      }
      &.efecto:focus ~ .focus-border {
        width: 100%;
        transition: 0.4s;
        left: 0;
      }
    }
    input[type="search"] {
      border: none!important;
      min-height: 1.4em!important;
    }
  }
  .form-row {
    margin-bottom: 4.4em;
    margin-top: -1em;
  }
  .tna {
    font-family: "vw-text", sans-serif;
    color: #757575;
    margin-left: 6%;
    display: inline-block;
    white-space: nowrap;
    @media(max-width: 767px) {
      display: block;
    }
  }
  .dropdown {
    background: transparent;
    .dropdown-toggle {
      border: none!important;
      background: transparent;
    }
    input,
    input[type="search"] {
      background: transparent!important;
    }
    .vs__selected-options {
      border-bottom: 1px solid $vw-input-border;
      padding: 0;
      align-items: center;
      background: transparent;
    }
    .selected-tag {
      color: $vw-blue;
      padding: 0;
      margin: 0;
      font-size: 1.25em;
      letter-spacing: -0.03em;
      @media(max-width: 767px) {
        font-size: 2em;
      }
    }
  }
  .form-control {
    border-radius: 0;
    background: transparent;
  }
  .form-control:focus {
    background: transparent;
  }
  @media (orientation: portrait) {
    .buttons > .row {
      display: flex;
      flex-direction: column;
    }
  }
  #marcha {
    margin: 4.8em 0;
    font-size: 1.3em;
    @media(max-width: 767px) {
      margin-top: 1em;
      .table-scroll {
        font-size: 10px;
        margin-left: 0;
        width: 100%;
      }
    }
  }
  #spacing1 {
    display: block;
    padding-top: 3.2em;
    @media(max-width: 767px) {
      padding-top: 4em;
    }
  }
  #spacing2 {
    display: block;
    padding-top: 4em;
    @media(max-width: 767px) {
      padding-top: 0;
    }
  }
  .margin-1 {
    margin-top: 2.5em;
  }
  .asterisco {
    color: #757575;
    font-size: 0.7em;
    margin: 0;
    margin-left: 8%;
    flex: 1;
    letter-spacing: 0.015em;
    margin-bottom: 4px;
    @media(max-width: 767px) {
      margin-left: 0;
      margin-top: 2em;
      font-size: 1.1em;
    }
  }
  .siguiente {
    margin-top: 4.5em;
  }
  #acepto {
    margin-top: 5em;
    font-size: 0.85em;
    line-height: 1.2em;
    @media(max-width: 767px) {
      margin-top: 2em;
      font-size: 1.2em;
    }
  }
  .table-sm {
    font-size: 1.2em;
  }
  .todos-min {
    @media(min-width: 1441px) {
      th, td {
        width: 20%;
        &.min-width {
          min-width: 310px;
        }
      }
    }
  }
  #loading {
    position: absolute;
    width: 150px;
    height: 150px;
    left: calc(50% - 75px);
    bottom: 15%;
    @media(max-width: 769px) {
      bottom: 40vh;
    }
  }
  @media(max-width: 767px) {
    .paso .table-main td.fix-col,
    .paso .table-main th.fix-col,
    .paso  .table-main td,
    .paso  .table-main th {
      font-size: 1.6em;
    }
    .paso .table-main th p,
    .paso .table-main td p {
      font-size: 1em;
    }
    #paso_2 .table-main td.fix-col,
    #paso_2 .table-main td {
      height: 5em;
    }
    #paso_3 .table-main th {
      min-width: 150px;
    }
    #paso_3 .table-main td.fix-col,
    #paso_3 .table-main td {
      height: 5em;
      p {
        flex-direction: row;
      }
    }
    #paso_3 .table-main td.fix-col p {
      height: 3em;
      overflow: hidden;
      display: block;
    }
    .desde {
      color: #757575;
      text-transform: capitalize;
      display: block;
      font-size: 0.9em;
      line-height: 1em;
      font-weight: 300;
    }
    #paso_3 .table-main.fixed td.fix-col {
      border-bottom: none;
    }
    #paso_3 a > small {
      font-size: 12px;
    }
    .form-row{
      margin: 0;
      &>div {
        margin-bottom: 2em;
      }
    }
    #paso_4 .siguiente {
      margin-top: 1em;
    }
    #paso_4 .table-main th+th {
      min-width: 120px;
    }
  }
</style>